<template>
    <b-card no-body class="card-notification" v-if="notif">
      <router-link :to="link"  :class="notif.see ? 'done' : ''">
        <div class="left">
            <PuSkeleton circle :loading="notif == null" height="40px" width="40px">
              <div class="icon" :class="type">
                <font-awesome-icon :icon="['fas', 'bullseye-arrow']"/>
              </div>
            </PuSkeleton>
        </div>

        <div class="right" :class="{isLoading : notif == null}">
          <h3>
              <PuSkeleton :loading="notif == null" :count="1" width='120px'>
                {{notif.title}}
              </PuSkeleton>
          </h3>
          <h4 class="secondTitle" :class="type" v-if="notif.message">
            <PuSkeleton :loading="notif == null" :count="1">
              {{notif.message}}
            </PuSkeleton>
          </h4>
        </div>

      </router-link>
    </b-card>
</template>


<script>
import card from '../card/Card'
//
export default {
  name: "CardNotification",
  components:{ 
  },
  mixins: [card],
  props:{
    notif:{
      default:null
    }
  },
  data(){
    return {
      link:'',
      type:''
    }
  },
  methods : {
  },  
  mounted (){
  },
  created(){
    if (this.notif){
      if (this.notif.type === 'TYPE_RESULT_PARCOURIR'){
        this.link = '/parcourir';
      } else if (this.notif.type === 'TYPE_RESULT_CONCOURS'){
        this.link = '/challenges/accueil';
      } else if (this.notif.type === 'TYPE_POSITIF_NUMBER'){
        this.link = '/critere/positifs';
      } else if (this.notif.type === 'TYPE_NEGATIF_NUMBER'){
        this.link = '/critere/negatifs';
      } else if (this.notif.type === 'TYPE_NEW_EXCURSION'){
        this.link = '/challenges/excursions';
      } else if (this.notif.type === 'TYPE_NEW_CONCOURS'){
        this.link = '/challenges/accueil';
      }
    }
  }   
}
</script>
